import {
  Collapse,
  IconButton,
  Table,
  TableBody,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import { TalentWorkOfferStatus } from "../../orderAPI";
import {
  TableCellFixedWidth,
  TableCellWide,
} from "../../../../common/components/functional/GroupedTable/styled";
import { useState } from "react";
import { ShortOrderWorkOfferRow } from "./ShortOrderWorkOfferRow";
import { useTranslation } from "react-i18next";

type Props = {
  workOffers: TalentWorkOfferStatus[];
  categoryName: string;
  isOrderFulfilled: boolean;
};

export const ShortOrderWorkOfferSubcategory = ({
  workOffers,
  categoryName,
  isOrderFulfilled,
}: Props) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const borderStyle = "1px solid rgba(0, 10, 68, 0.11)";

  return (
    <>
      <Table size="small" sx={{ padding: 0, margin: 0 }}>
        <TableHead>
          <TableRow>
            <TableCellFixedWidth />
            <TableCellWide>
              <Typography color="primary" fontWeight={600} fontSize={14}>
                <IconButton
                  size="small"
                  onClick={() => setIsOpen(!isOpen)}
                  sx={{
                    padding: 0,
                    margin: 0,
                    marginRight: 1,
                    color: "#4A1D9C",
                  }}
                >
                  {isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                </IconButton>
                {categoryName.toLocaleUpperCase()}
              </Typography>
            </TableCellWide>
            <TableCellFixedWidth
              sx={{
                borderLeft: borderStyle,
              }}
            />
            <TableCellFixedWidth
              sx={{
                borderLeft: borderStyle,
              }}
            />
            <TableCellFixedWidth
              sx={{
                borderLeft: borderStyle,
                borderRight: borderStyle,
              }}
            />
          </TableRow>
        </TableHead>
      </Table>
      <Collapse in={isOpen}>
        <Table size="small" sx={{ padding: 0, margin: 0 }}>
          <TableBody>
            {workOffers?.length ? (
              workOffers?.map((workOffer, i) => (
                <ShortOrderWorkOfferRow
                  key={workOffer.id + i}
                  talentWorkOffer={workOffer}
                  sx={
                    i % 2 === 0
                      ? {
                          backgroundColor: "#FAFAFB",
                        }
                      : {
                          backgroundColor: "#FFFFFF",
                        }
                  }
                  isOrderFulfilled={isOrderFulfilled}
                />
              ))
            ) : (
              <TableRow>
                <TableCellFixedWidth>{t("common:noItems")}</TableCellFixedWidth>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </Collapse>
    </>
  );
};
